function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M308.53,427H287.31a1.39,1.39,0,0,1-1.39-1.39v-6.26a1.39,1.39,0,0,1,1.39-1.39h21.22a1.39,1.39,0,0,1,1.39,1.39v6.26A1.39,1.39,0,0,1,308.53,427Zm-21.22-8a.39.39,0,0,0-.39.39v6.26a.39.39,0,0,0,.39.39h21.22a.39.39,0,0,0,.39-.39v-6.26a.39.39,0,0,0-.39-.39Z",
  transform: "translate(-285.92 -414.88)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M309.72,419H286l3.59-4.08h16.93Zm-21.53-1h19.47L306,415.88H290Z",
  transform: "translate(-285.92 -414.88)"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 3.08,
  y: 7.13,
  width: 7.98,
  height: 1
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 18.07,
  y: 7.13,
  width: 3,
  height: 1
});

var SvgFilesListingDrive = function SvgFilesListingDrive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "14px",
    fill: "#444445",
    "data-name": "Layer 1",
    viewBox: "0 0 24 12.13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilesListingDrive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/files_listing_drive.4048fd7b.svg";
export { ForwardRef as ReactComponent };